import 'es6-promise/auto'
import bus from '../shared/eventbus';
import axios from '../shared/axios';
import {requestSuccess, requestError, responseSuccess, responseError} from './etc/interceptors';
import route from './routing/routeResolver';
import Lang from 'lang.js';
import {translated} from '../shared/helpers';
import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: Jobtoolz.pusher_api_key,
    cluster: Jobtoolz.pusher_app_cluster,
    forceTLS: true,
    namespace: 'App.Events',
});

window.bus = bus;
window.axios = axios;
window.route = route;
window.translated = translated;
window.lang = new Lang({
    locale: document.documentElement.lang,
    messages: Jobtoolz.translations
});

axios.interceptors.request.use(requestSuccess, requestError);
axios.interceptors.request.use(config => {
	let locale = localStorage.getItem('locale');

	if (locale) {
		config.headers['Accept-Language'] = locale;
	}

	return config;
});

axios.interceptors.response.use(responseSuccess, responseError);

window.trackBehaviour = function (event, props = {})
{
    axios.post(route('api.manage.track'), {
        event,
        props,
    }, {
        // Make sure our promise never gets rejected, even when we have
        // an error in our response. We don't want to alert users if we
        // have an issue in our tracking.
        validateStatus: () => true,
    });
}
